export default {
  es: {
    image: {
      src: "/assets/images/sections/great-place-to-work-people.webp",
      srcMobile: "/assets/images/sections/Best-place-to-work-mobile.webp",
      alt: "Nuestros certificados de un gran lugar donde trabajar",
      size: "medium",
      class: "lateral-left",
    },
    imageTwo: {
      src: "/assets/images/sections/Great-place-Logo.png",
      alt: "logo great place to work 2024 | España",
      class: "lateral-left",
    },
    imageThree: {
      src: "/assets/images/sections/great-place-mexico.png",
      alt: "logo best place to work 2023 | México",
      class: "lateral-left",
    },
  },
  en: {
    image: {
      src: "/assets/images/sections/great-place-to-work-people.webp",
      srcMobile: "/assets/images/sections/Best-place-to-work-mobile.webp",
      alt: "Nuestros certificados de un gran lugar donde trabajar",
      size: "medium",
      class: "lateral-left",
    },
    imageTwo: {
      src: "/assets/images/sections/Great-place-Logo.png",
      alt: "logo great place to work 2024 | Spain",
      class: "lateral-left",
    },
    imageThree: {
      src: "/assets/images/sections/great-place-mexico.png",
      alt: "logo best place to work 2023 | Mexico",
      class: "lateral-left",
    },
  },
};
